// CONSTANTS are all caps.
const NS = 'SimpleVideoBlock';
const CLS = 'simpleVideoBlock';
const BLK = '.' + CLS + '-';

// Import stuff here if you need to or even better to import them dynamically
// for ex. of dynamic import check out ./loadBlk.js using Webpack dynamic imports as chunks.
// import $ from 'jquery'
// import rVideoBlock from './VideoBlock.jsx';
// import React from 'react';
// import ReactDOM from 'react-dom';

function getIframe(type, src) {
	let youtubeTemplate = `
		<iframe class="embed-responsive-item" src="https://www.youtube.com/embed/${src}" allowfullscreen="allowfullscreen" allowscriptaccess="always" allow="autoplay"></iframe>
	`;
	let vimeoTemplate = `
		<iframe src="https://player.vimeo.com/video/${src}?embedparameter=value" width="640" height="360" frameborder="0" allowfullscreen></iframe>
	`

	let mp4Template = `
		<video class="embed-responsive-item" controls>
			<source src="${src}">
		</video>
	`
	if(type == 'youtube') {return youtubeTemplate; }
	if(type == 'mp4') {return mp4Template; }
	else {
		return vimeoTemplate;
	}
}

function getModal(type, src) {
	// <iframe class="embed-responsive-item" src="${src}" allowfullscreen="allowfullscreen" allowscriptaccess="always" allow="autoplay"></iframe>
	let template = `
	<div id="videoModal" class="modal hide fade" tabindex="-1" role="dialog" aria-hidden="false">
		<div class="modal-dialog" role="document">
			<div class="iconClose close mb-3" data-dismiss="modal" aria-label="Close"></div>
			<div class="modal-content">
				<div class="modal-body p-0">
					<!-- 16:9 aspect ratio -->
					<div class="embed-responsive embed-responsive-16by9">
						${getIframe(type, src)}
					</div>
				</div>
			</div>
		</div>
	</div>
	`;

	return $(template);
}

export class SimpleVideoBlock {

	constructor($el) {
		// $el is the blk node return by the loadVideoBlock function
		this.el = $el;
		this.$el = $($el);
		this.$elPar = $(document.body);

		this.isModal = ('true' === this.$el.data('lightbox').toString());
		this.$iframe = getIframe(this.$el.data('videotype'), this.$el.data('videoid'));
		this.$modal = getModal(this.$el.data('videotype'), this.$el.data('videoid'));

		this.init();
	}

	init() {
		this.$el.find('.simpleVideoBlock-play-btn').on('click', () => {
			(this.isModal)
				? this.showModal()
				: this.showIframe();

		})
	}

	showIframe() {
		this.el.querySelector('.embed-responsive').innerHTML = this.$iframe;
	}

	showModal() {
		// append to body incase not working inside the slick
		this.$elPar.append(this.$modal);
		// this.$el.append(this.$modal);
		$('#videoModal').modal();

		this.listenHideModal();
	}

	listenHideModal() {
		$('#videoModal').on('hide.bs.modal', () => {
			$('#videoModal').remove();
		});
	}


	// Add more functions like on above here
}
